import {useCallback, useState} from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import type {MinimalProcessTaskSchema, UpdateProcessSchema} from './ProcessTaskSchemaUtils';

export interface FolderState {
  defaultCreationFolderId: string | null;
  isDefaultCreationFolderInaccessible: boolean;
  defaultEntryExecutionFolderId: string | null;
  isDefaultEntryExecutionFolderInaccessible: boolean;

  setDefaultCreationFolderId: React.Dispatch<React.SetStateAction<string | null>>;
  setDefaultEntryExecutionFolderId: React.Dispatch<React.SetStateAction<string | null>>;

  applyFolderUpdates: (params: UpdateProcessSchema) => void;
}

export function useFolderState(processTaskSchema: MinimalProcessTaskSchema | null): FolderState {
  const [defaultCreationFolderId, setDefaultCreationFolderId] = useState<string | null>(
    processTaskSchema?.defaultCreationFolderOrInaccessible != null &&
      !isInaccessible(processTaskSchema.defaultCreationFolderOrInaccessible)
      ? processTaskSchema.defaultCreationFolderOrInaccessible.id
      : null
  );
  const [isDefaultCreationFolderInaccessible, _setIsDefaultCreationFolderInaccessible] = useState(
    processTaskSchema?.defaultCreationFolderOrInaccessible != null &&
      isInaccessible(processTaskSchema.defaultCreationFolderOrInaccessible)
  );
  const [defaultEntryExecutionFolderId, setDefaultEntryExecutionFolderId] = useState<string | null>(
    processTaskSchema?.defaultEntryExecutionFolderOrInaccessible != null &&
      !isInaccessible(processTaskSchema.defaultEntryExecutionFolderOrInaccessible)
      ? processTaskSchema.defaultEntryExecutionFolderOrInaccessible.id
      : null
  );
  const [isDefaultEntryExecutionFolderInaccessible, _setIsDefaultEntryExecutionFolderInaccessible] = useState(
    processTaskSchema?.defaultEntryExecutionFolderOrInaccessible != null &&
      isInaccessible(processTaskSchema.defaultEntryExecutionFolderOrInaccessible)
  );

  const applyFolderUpdates = useCallback((params: UpdateProcessSchema): void => {
    if (params.defaultCreationFolderId !== undefined) {
      setDefaultCreationFolderId(params.defaultCreationFolderId);
      _setIsDefaultCreationFolderInaccessible(false);
    }
    if (params.defaultEntryExecutionFolderId !== undefined) {
      setDefaultEntryExecutionFolderId(params.defaultEntryExecutionFolderId);
      _setIsDefaultEntryExecutionFolderInaccessible(false);
    }
  }, []);

  return {
    defaultCreationFolderId,
    isDefaultCreationFolderInaccessible,
    defaultEntryExecutionFolderId,
    isDefaultEntryExecutionFolderInaccessible,

    setDefaultCreationFolderId,
    setDefaultEntryExecutionFolderId,

    applyFolderUpdates,
  };
}
